import { Flex, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import {
  formatSelectOptions,
  Select,
} from '~/packages/common-frontend/components/Select';
import { Typography } from '~/packages/common-frontend/components/Typography';
import { errorToastConfig } from '~/packages/common-frontend/constants';
import { WipConfig } from '~/packages/creditAgreements/ui/types';

interface PortfolioCovenantValueTypeSelectorProps {
  wipConfig?: WipConfig;
  fullPropertyKey: string;
  valueTypeProperty: CreditAgreement.Config.PortfolioCovenant.ValueType;
}
export const PortfolioCovenantValueTypeSelector = ({
  wipConfig,
  fullPropertyKey,
  valueTypeProperty,
}: PortfolioCovenantValueTypeSelectorProps) => {
  const toast = useToast();

  return (
    <Flex mb="2" alignItems="center" gap="3">
      <Typography
        variant="base"
        fontWeight="bold"
        TextProps={{ fontSize: 'large' }}
      >
        Value Type:
      </Typography>
      <Select
        isDisabled={!wipConfig?.isMutateAllowed(fullPropertyKey)}
        value={valueTypeProperty}
        options={formatSelectOptions(
          CreditAgreement.Config.PortfolioCovenant.ValueTypes,
          'title',
        )}
        onChange={async (newValue) => {
          if (!newValue) return;
          if (newValue === valueTypeProperty) return;
          if (!wipConfig?.isMutateAllowed(fullPropertyKey)) return;

          try {
            await wipConfig.saveAndUpdateConfigCreditAgreementWip({
              wipConfig,
              propertyKey: fullPropertyKey,
              updatedProperty: newValue,
            });
          } catch (error) {
            Sentry.captureException(error);
            toast({
              ...errorToastConfig,
              title: 'Failed to update value type for Portfolio Covenant',
            });
          }
        }}
        containerFlexProps={{ width: '200px' }}
        width="200px"
      />
    </Flex>
  );
};
